import React, { useEffect, useState } from 'react';
import logo from '../../images/logo.png';
import './Profile.css';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import TikTokIcon from '../TikTokIcon/TikTokIcon';
import useSiteConfig from '../useSiteConfig';

export default function Profile() {
    const { logo: siteLogo } = useSiteConfig();
    const [contactos, setContactos] = useState([]);

    useEffect(() => {
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const lista = data.contacto || [];
                setContactos(lista[0] || {});
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    return (
        <div className='profileContain'>
            <img src={siteLogo || logo} alt="logo" onError={(e) => { e.target.src = logo; }} />
            <h2>{contactos.nombre}</h2>
            <div className='socials'>
                {contactos.instagram && (
                    <Anchor to={contactos.instagram} target="_blank" rel="noopener noreferrer" title="Instagram">
                        <i className='fa fa-instagram'></i>
                    </Anchor>
                )}
                {contactos.telefono && (
                    <Anchor to={`tel:${contactos.telefono}`} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                        <i className='fa fa-whatsapp'></i>
                    </Anchor>
                )}
                {contactos.facebook && (
                    <Anchor to={contactos.facebook} target="_blank" rel="noopener noreferrer" title="Facebook">
                        <i className='fa fa-facebook'></i>
                    </Anchor>
                )}
                {contactos.tiktok && (
                    <Anchor
                        to={contactos.tiktok.startsWith('http') ? contactos.tiktok : `https://www.tiktok.com/@${contactos.tiktok.replace(/^@/, '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="TikTok"
                    >
                        <TikTokIcon size={18} />
                    </Anchor>
                )}
            </div>
            <div className='profileText'>
                <Anchor to={`mailto:${contactos.email}`} target="_blank" rel="noopener noreferrer">{contactos.email}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion || '')}`} target="_blank" rel="noopener noreferrer">{contactos.direccion}</Anchor>
            </div>
        </div>
    );
}
